<template>
    <div>
        <HomeSection></HomeSection>
        <WhyUseSection></WhyUseSection>
        <FeatureSection></FeatureSection>
        <Screenshot></Screenshot>
        <!-- <TestimonialSection></TestimonialSection> -->
        <!-- <TeamSection></TeamSection> -->
        <DownloadSection></DownloadSection>
        <ContactSection></ContactSection>
        <Copyright></Copyright>
    </div>
</template>

<script>
import DownloadSection from "@landing/Components/DownloadSection.vue";
import FeatureSection from "@landing/Components/FeatureSection.vue";
import HomeSection from "@landing/Components/HomeSection.vue";
import WhyUseSection from "@landing/Components/WhyUseSection.vue";
import TeamSection from "@landing/Components/TeamSection.vue";
import TestimonialSection from "@landing/Components/TestimonialSection.vue";
import ContactSection from "@landing/Components/ContactSection.vue";
import Copyright from "@landing/Components/Copyright.vue";
import Screenshot from "@landing/Components/Screenshot.vue";

export default {
    components: {
        HomeSection,
        WhyUseSection,
        TestimonialSection,
        TeamSection,
        FeatureSection,
        DownloadSection,
        ContactSection,
        Copyright,
        Screenshot,
    },
};
</script>
